import { get } from "helpers/api_helper/Authentication/authenticationApiHelper"
import * as url from "helpers/url_helper/url_helper"


// export const getSideBarMenuData = userGuid => get(url.SIDEBAR_MENU_DATA,{ params: { userGuid } })
export const getSideBarMenuData = () => get(url.SIDEBAR_MENU_DATA)